/**
 * A hook to return full article data.
 *
 * > **💡 NOTE**: this doesn't return any partially fetched articles so it can only be used on an article page.
 *
 * @module
 */
import { useContext } from 'react';
import { ArticleFullContext } from '../contexts';
/**
 *
 * # useArticleFull
 *
 * Usage example:
 *
 * ```javascript
 * import { useArticleFull } from "@elevio/kb-kit/lib/hooks";
 *
 * function MyArticlePage() {
 *   const article = useArticleFull();
 *   console.log(article); // IArticleFull | undefined
 *
 *   return (
 *     ...
 *   )
 * }
 * ```
 */
export function useArticleFull() {
    const article = useContext(ArticleFullContext);
    return article;
}
//# sourceMappingURL=useArticleFull.js.map